import { render, staticRenderFns } from "./AppSettingsDropdown.vue?vue&type=template&id=2a357803&"
import script from "./AppSettingsDropdown.vue?vue&type=script&lang=js&"
export * from "./AppSettingsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports